import React, { forwardRef } from 'react';
import './Button.css';

export interface BaseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'text' | 'critical';
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  isLoading?: boolean;
  className?: string;
}

const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  isLoading = false,
  className = '', 
  disabled,
  ...props
}, ref) => {
  const buttonClasses = [
    'button',
    `button-${variant}`,
    `button-${size}`,
    isLoading && 'button-loading',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      ref={ref}
      className={buttonClasses}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <div className="button-spinner" />
      ) : (
        children
      )}
    </button>
  );
});

BaseButton.displayName = 'BaseButton';

export default BaseButton; 